module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.b8e4297.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/Roboto-Bold.ttf
// module id = XvKm
// module chunks = 0